import Homesatays from "./Homesatays";
import PublicationSuccess from "../Facilities/PublicationSuccess";


const createHomestays = [
    {
        title: 'Enter your ad text',
        progress: { title: 'Animal boarding', step: 2 },
        component: Homesatays, valid: true, required: true,
    },
    {
        progress: { title: 'Thank you', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default  createHomestays
